// コンテンツ高さ制御
$(function() {
  var hH = $('.ts_header_area').height();
  var tH = $('.ts_header').height();
  
  $(window).on('load resize', function() {  
    $('.ts_contents_area').css('margin-top',hH);
    $('.sp_search').css('top',tH + 1);
    $('.sp_menu').css('top',tH + 1);
  });
});	

// TOPスライダー（slick）
$(function () {
  $(".top_slider").slick({
    arrows: false,
    autoplay: true,
    adaptiveHeight: true,
    centerMode: true,
    centerPadding: "16%",
    dots: true,
    responsive: [
      {
        breakpoint: 769, // 414px以下のサイズに適用
        settings: {
          centerMode: false,
        },
      },
    ],
  });
});

// 商品詳細（slick）
$(function () {
  $(".main_image_ts").slick({
    arrows: true,
    autoplay: false,
    prevArrow: '<button type="button" class="slick-prev"><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/allow_prev_detail.svg" alt="" preserveAspectRatio="none"></button>',
    nextArrow: '<button type="button" class="slick-next"><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/allow_next_detail.svg" alt="" preserveAspectRatio="none"></button>',
    asNavFor: ".main_thumbnail_ts",
    //initialSlide: 3,
  });
  $(".main_thumbnail_ts").slick({
    infinite: false,
    arrows: false,
    autoplay: false,
    loop: false,
    //slidesToShow: 20,
    asNavFor: ".main_image_ts",
    focusOnSelect: true,
  });
});

// SKU表示強制変更
$(function () {
  if(document.URL.match(/products/)) {
    // SKUコード取得
    var skudummycode = $(".product-sku dl dd").text();
    // アンダーバーがあるときのみ発動
    if (skudummycode.indexOf("_") >= 0) {
      // アンダーバーでsplitして最後を取得
      var skudummycode_s = skudummycode.split("_");
      var sku_last =  skudummycode_s.slice(-1)[0];
      // テキスト置換
      $(".product-sku dl dd").text(sku_last);
    }    
  }
});

// DOM要素を監視して、ボタン推されたら以下を再実行
$(function(){
  if(document.URL.match(/products/)) {
    const observer_sku = new MutationObserver(function () {
      
      // SKUコード取得
      var skudummycode = $(".product-sku dl dd").text();
      // アンダーバーがあるときのみ発動
      if (skudummycode.indexOf("_") >= 0) {
        // アンダーバーでsplitして最後を取得
        var skudummycode_s = skudummycode.split("_");
        var sku_last =  skudummycode_s.slice(-1)[0];

        // テキスト置換
        $(".product-sku dl dd").text(sku_last);
      }
      
    })

    // 監視divのid値は動的採番の為、テンプレコピー時に変わる可能性があるので注意
    observer_sku.observe(document.getElementById("sku-template--25888902512952__main"), { childList: true, subtree: true })
  }
});

$(function(){
  if(document.URL.match(/products/)) {
    const observer_sku_2 = new MutationObserver(function () {
      
      // SKUコード取得
      var skudummycode = $(".product-sku dl dd").text();
      // アンダーバーがあるときのみ発動
      if (skudummycode.indexOf("_") >= 0) {
        // アンダーバーでsplitして最後を取得
        var skudummycode_s = skudummycode.split("_");
        var sku_last =  skudummycode_s.slice(-1)[0];
        // テキスト置換
        $(".product-sku dl dd").text(sku_last);
      }
      
    })

    // 監視divのid値は動的採番の為、テンプレコピー時に変わる可能性があるので注意
    observer_sku_2.observe(document.getElementById("sku-template--23881150923064__main"), { childList: true, subtree: true })
  }
});

// カラバリボタンとスライダーを連動させる
$(function () {
  $('.product-form__input label').on('click', function() {
    index = $(this).index('label');
    $('.main_image_ts').slick('slickGoTo', index -1, false);
    $('.main_thumbnail_ts').slick('slickGoTo', index -1, false);
  });
});

// 対応機種（slick）
$(function () {
  $(".related_products_ts_list").slick({
    //autoplay: false,
    dots: false,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    //adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-prev"><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/allow_prev.svg" alt="" preserveAspectRatio="none"></button>',
    nextArrow: '<button type="button" class="slick-next"><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/allow_next.svg" alt="" preserveAspectRatio="none"></button>',
    responsive: [
      {
        breakpoint: 769, // 414px以下のサイズに適用
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });
});

// 関連商品カテゴリ（slick）
$(function () {
  $(".related_category_ts_list").slick({
    //autoplay: false,
    dots: false,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    //adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-prev"><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/allow_prev.svg" alt="" preserveAspectRatio="none"></button>',
    nextArrow: '<button type="button" class="slick-next"><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/allow_next.svg" alt="" preserveAspectRatio="none"></button>',
    responsive: [
      {
        breakpoint: 769, // 414px以下のサイズに適用
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });
});

// ヘッダー制御
$(function() {
	var headerHeight = $('.ts_header_area').outerHeight();
	var	startPos = 0;
	$(window).on('load scroll', function() {
		var scrollPos = $(this).scrollTop();
		if ( scrollPos > startPos && scrollPos > headerHeight ) {
			$('.ts_header_area').css('top', '-' + headerHeight + 'px');
            // メニュー残存した場合、強制的に消去
            setTimeout(function(){
              $(".global_nav_pc li div").css('display','none');
            },500);
		} else {
			$('.ts_header_area').css('top', '0');
		}
		startPos = scrollPos;
	});
});	

// グロナビ
$(function () {
    $(".global_nav_pc").children("li").hover(function(){
        $(this).children("div").stop().slideToggle(180);
    });
});

// サイドメニュー制御
$(function () {
  $('.js-accordion-title').on('click', function () {
    $(this).next().slideToggle(200);
    $(this).toggleClass('open', 200);
  });
});

// SP メニュー展開
$(function () {
  $('.js-accordion-title-child').on('click', function () {
    $(this).next().slideToggle(200);
    $(this).toggleClass('open', 200);
  });
});

// SP 検索アイコン・検索ウインドウ
$(function () {
  $('.open_search').click(function() {    
    $(this).toggleClass('active');
    
    // メニュー展開処理
    if($('.sp_menu').hasClass('is_open')){
      // スライドメニューが開いている場合 
      $('.open_menu').toggleClass('active');
      $('.sp_menu').removeClass('is_open');
      setTimeout(function(){
        $('.sp_search').toggleClass('is_open');
      },500);
    }else{
      // スライドメニューが閉じている場合
      $('.sp_search').toggleClass('is_open');
      $('body').toggleClass('contents_fixed');
      $('html').toggleClass('contents_fixed_html');
    }
    
  });
});

//SP ハンバーガーメニュー・スライドインメニュー
$(function () {
  $('.open_menu').click(function() {
    $(this).toggleClass('active');
    
    // メニュー展開処理
    if($('.sp_search').hasClass('is_open')){
      // 検索メニューが開いている場合 
      $('.open_search').toggleClass('active');
      $('.sp_search').removeClass('is_open');
      setTimeout(function(){
        $('.sp_menu').toggleClass('is_open');
      },500);
    }else{
      // 検索メニューが閉じている場合
      $('.sp_menu').toggleClass('is_open');
      $('body').toggleClass('contents_fixed');
      $('html').toggleClass('contents_fixed_html');
    }
    
  });
});

//商品詳細 カート投入ボタン固定
$(function () {

  if(document.URL.match(/products/)) {

  // ターゲット要素座標固定
  if (window.matchMedia( '(max-width:768px)' ).matches) {
    var target_point = $('.btn_change_point').offset().top;
  } else {
    var target_point = $('.btn_change_point').offset().top;
  }
    
  // ダミーブロックに書き込むコンテンツの高さを事前に取得
  var contents_h = $('.product_infomation').height();
    
  // ヘッダの高さも事前に取得
  var header_h = $('.ts_header_area').outerHeight();
    
  // スクロールされたら実行
  $(window).on('scroll', function(){
    
    // ブラウザスクロール量を動的に取得
    var target_point2 = $(this).scrollTop();
    
    // スクロール量がターゲット座標を超えたらカートブロック丸ごとfixed処理
    if( target_point2 - header_h > target_point ) {  
      $('.product_infomation').addClass('btn_mordal');
      $('.product_infomation_dummy').css('height',contents_h);
      $('.color_code_area').css('display','flex');

      $('.product-barcode').css('display','none');
      $('.product-sku').css('display','none');
      $('.price__sale .default-price-item').css('display','none');
      $('.product_code_block dt').css('display','none');

      //$('.yotpo-widget-instance').css('display','none');
      $('.jdgm-prev-badge').css({'visibility':'hidden','width':'0'});

      // フッタかさ上げ
      var dummy_cart_h = $('.btn_mordal').outerHeight();
      $('.ts_footer_area').css('margin-bottom',dummy_cart_h);
      
      // 上に戻るボタンもかさ上げ
      $('#page-top').css('bottom',dummy_cart_h + 20);

      // 現在チェック中のボタンvalue値を取得してテキスト書き込み
      $('.variant-selects_ts input[name="カラー"]:checked').each(function() {
        var r = $(this).val();
        $('.color_code').html(r);
      });
      $('.variant-selects_ts input[name="お手持ち製品のカラーをご選択下さい。<small>※商品画像クリックでの選択はできません</small>"]:checked').each(function() {
        var r = $(this).val();
        $('.color_code').html(r);
      });
      $('.variant-selects_ts input[name="購入したいパーツ種類（商品画像参照）をご選択ください。<small>※商品画像クリックでの選択はできません</small>"]:checked').each(function() {
        var s = $(this).val();
        $('.parts_code').html("／ " + s);
      });
      $('.variant-selects_ts input[name="種類"]:checked').each(function() {
        var t = $(this).val();
        $('.parts_code').html("／ " + t);
      });
      
    } else {
      
      $('.product_infomation').removeClass('btn_mordal');
      $('.product_infomation_dummy').css('height',"0");
      $('.color_code_area').css('display','none');

      $('.product-barcode').css('display','block');
      $('.product-sku').css('display','block');
      $('.price__sale .default-price-item').css('display','inline');
      $('.product_code_block dt').css('display','inline');

      //$('.yotpo-widget-instance').css('display','block');
      $('.jdgm-prev-badge').css({'visibility':'visible','width':'auto'});

      $('.ts_footer_area').css('margin-bottom','0');

      $('#page-top').css('bottom','60px');

    }
  });

  }
  
});

// 現在選択中のカラーをテキストで表示
$(function () {
  
  // 現在チェック中のボタンvalue値を取得してテキスト書き込み
  $('.variant-selects_ts input[name="カラー"]:checked').each(function() {
    var btm_r = $(this).val();
    $('.color_code_bottom').html(btm_r);
  });
  $('.variant-selects_ts input[name="お手持ち製品のカラーをご選択下さい。<small>商品画像クリックでの選択はできません</small>"]:checked').each(function() {
    var btm_r = $(this).val();
    $('.color_code_bottom').html(btm_r);
  });
  $('.variant-selects_ts input[name="購入したいパーツ種類<small>（商品画像参照）</small>をご選択ください。<small>商品画像クリックでの選択はできません</small>"]:checked').each(function() {
    var btm_s = $(this).val();
    $('.parts_code_bottom').html(btm_s);
  });
  $('.variant-selects_ts input[name="種類"]:checked').each(function() {
    var btm_t = $(this).val();
    $('.parts_code_bottom').html(btm_t);
  });
  
  $('.product-form__input label').on('click', function() {

    var btm_new_r = $(this).prev('input[name="カラー"]').val();
    var btm_new_m = $(this).prev('input[name="お手持ち製品のカラーをご選択下さい。<small>商品画像クリックでの選択はできません</small>"]').val();
    var btm_new_s = $(this).prev('input[name="購入したいパーツ種類<small>（商品画像参照）</small>をご選択ください。<small>商品画像クリックでの選択はできません</small>"]').val();
    var btm_new_t = $(this).prev('input[name="種類"]').val();

    $('.color_code_bottom').html(btm_new_r);
    $('.color_code_bottom').html(btm_new_m);
    $('.parts_code_bottom').html(btm_new_s);
    $('.parts_code_bottom').html(btm_new_t);
    
  });
  
});

// 選択中アイテムのカートvalueを取得
$(function () {
  var cart_sku = $('.buy_button_ts form input[name="id"]').val();
  // カラーをクリックしたらvalue再取得
  $('.variant-selects_ts input').on('click', function() {
    var cart_sku_after = $('.buy_button_ts form input[name="id"]').val();
  });
});

// 商品アイコンにカラークラス付与
$(function(){
  //$(".product_icon li:contains('送料無料')").addClass('icon_sendfree');
  $(".product_icon li:contains('海外OK')").addClass('icon_overseas');
  $(".product_icon li:contains('プロテクトイオン')").addClass('icon_protection');
  $(".product_icon li:contains('マイナスイオン')").addClass('icon_minusion');
  $(".product_icon li:contains('日本製')").addClass('icon_madeinjapan');
  $(".product_icon li:contains('1200W')").addClass('icon_1200w');
  $(".product_icon li:contains('1300W')").addClass('icon_1300w');
  $(".product_icon li:contains('1400W')").addClass('icon_1400w');
  $(".product_icon li:contains('大風量')").addClass('icon_bigwind');
  $(".product_icon li:contains('軽量タイプ')").addClass('icon_lightweight');
  $(".product_icon li:contains('コンパクト')").addClass('icon_compact');
  $(".product_icon li:contains('USB対応')").addClass('icon_usb');
  $(".product_icon li:contains('コードレス')").addClass('icon_cordless');
  $(".product_icon li:contains('水洗いOK')").addClass('icon_waterwash');
  $(".product_icon li:contains('パーツ水洗いOK')").addClass('icon_partswash');
  $(".product_icon li:contains('充電式')").addClass('icon_rechargeable');
  $(".product_icon li:contains('充電交流両用')").addClass('icon_dualuse');
  $(".product_icon li:contains('乾電池式')").addClass('icon_drybattery');
  $(".product_icon li:contains('速乾')").addClass('icon_quickdrying');
});

// カラーチップテキスト アイコンへ書き換え
$(function(){
  $(".color_chip_icon li:contains('白系')").replaceWith('<li><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/ts_chip_whire.png" alt="" preserveAspectRatio="none"></li>');
  $(".color_chip_icon li:contains('黒系')").replaceWith('<li><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/ts_chip_black.png" alt="" preserveAspectRatio="none"></li>');
  $(".color_chip_icon li:contains('グレー系')").replaceWith('<li><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/ts_chip_gray.png" alt="" preserveAspectRatio="none"></li>');
  $(".color_chip_icon li:contains('シルバー系')").replaceWith('<li><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/ts_chip_silver.png" alt="" preserveAspectRatio="none"></li>');
  $(".color_chip_icon li:contains('ブラウン系')").replaceWith('<li><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/ts_chip_brown.png" alt="" preserveAspectRatio="none"></li>');
  $(".color_chip_icon li:contains('ピンク系')").replaceWith('<li><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/ts_chip_pink.png" alt="" preserveAspectRatio="none"></li>');
  $(".color_chip_icon li:contains('赤系')").replaceWith('<li><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/ts_chip_red.png" alt="" preserveAspectRatio="none"></li>');
  $(".color_chip_icon li:contains('水色・青系')").replaceWith('<li><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/ts_chip_blue.png" alt="" preserveAspectRatio="none"></li>');
});

// 商品一覧通常ページ 高さ揃え
$(function(){
  $('.main-collection-product-grid_ts .status_icon').matchHeight();
  $('.main-collection-product-grid_ts .product_brand').matchHeight();
  $('.main-collection-product-grid_ts .product_title').matchHeight();
  $('.main-collection-product-grid_ts .product_price').matchHeight();
});

// 商品価格テキストを強制書き換え
$(function(){
  $('.price-item').each(function(){
	var sale_txt = $(this).html();
	$(this).html(sale_txt.replace(/から/g,''));
  });
});

// DOM要素を監視して、絞り込み発火したら以下を再実行
$(function(){
  if(document.URL.match(/collections/) || document.URL.match(/search/)) {
  
  const observer = new MutationObserver(function () {
    //$(".product_icon li:contains('送料無料')").addClass('icon_sendfree');
    $(".product_icon li:contains('海外OK')").addClass('icon_overseas');
    $(".product_icon li:contains('プロテクトイオン')").addClass('icon_protection');
    $(".product_icon li:contains('マイナスイオン')").addClass('icon_minusion');
    $(".product_icon li:contains('日本製')").addClass('icon_madeinjapan');
    $(".product_icon li:contains('1200W')").addClass('icon_1200w');
    $(".product_icon li:contains('1300W')").addClass('icon_1300w');
    $(".product_icon li:contains('1400W')").addClass('icon_1400w');
    $(".product_icon li:contains('大風量')").addClass('icon_bigwind');
    $(".product_icon li:contains('軽量タイプ')").addClass('icon_lightweight');
    $(".product_icon li:contains('コンパクト')").addClass('icon_compact');
    $(".product_icon li:contains('USB対応')").addClass('icon_usb');
    $(".product_icon li:contains('コードレス')").addClass('icon_cordless');
    $(".product_icon li:contains('水洗いOK')").addClass('icon_waterwash');
    $(".product_icon li:contains('パーツ水洗いOK')").addClass('icon_partswash');
    $(".product_icon li:contains('充電式')").addClass('icon_rechargeable');
    $(".product_icon li:contains('充電交流両用')").addClass('icon_dualuse');
    $(".product_icon li:contains('乾電池式')").addClass('icon_drybattery');
    $(".product_icon li:contains('速乾')").addClass('icon_quickdrying');
    
    $(".color_chip_icon li:contains('白系')").replaceWith('<li><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/ts_chip_whire.png" alt="" preserveAspectRatio="none"></li>');
    $(".color_chip_icon li:contains('黒系')").replaceWith('<li><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/ts_chip_black.png" alt="" preserveAspectRatio="none"></li>');
    $(".color_chip_icon li:contains('グレー系')").replaceWith('<li><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/ts_chip_gray.png" alt="" preserveAspectRatio="none"></li>');
    $(".color_chip_icon li:contains('シルバー系')").replaceWith('<li><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/ts_chip_silver.png" alt="" preserveAspectRatio="none"></li>');
    $(".color_chip_icon li:contains('ブラウン系')").replaceWith('<li><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/ts_chip_brown.png" alt="" preserveAspectRatio="none"></li>');
    $(".color_chip_icon li:contains('ピンク系')").replaceWith('<li><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/ts_chip_pink.png" alt="" preserveAspectRatio="none"></li>');
    $(".color_chip_icon li:contains('赤系')").replaceWith('<li><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/ts_chip_red.png" alt="" preserveAspectRatio="none"></li>');
    $(".color_chip_icon li:contains('水色・青系')").replaceWith('<li><img src="//cdn.shopify.com/s/files/1/0695/7603/2568/t/3/assets/ts_chip_blue.png" alt="" preserveAspectRatio="none"></li>');    
    
    $('.main-collection-product-grid_ts .status_icon').matchHeight();
    $('.main-collection-product-grid_ts .product_brand').matchHeight();
    $('.main-collection-product-grid_ts .product_title').matchHeight();
    $('.main-collection-product-grid_ts .product_price').matchHeight();
  })
  observer.observe(document.getElementById("FacetFiltersForm"), { childList: true, subtree: true })

  }
});

// お問い合わせフォーム プルダウン制御
$(function(){
  $('.contact_select select').on('change', function (){
    const selected = $('.contact_select select').val();
    if ( selected === 'ご注文に関するお問い合わせ' ) {
      $('.contact_select_01').css('display', 'block');

      //$('.contact_select_01 input').addClass('required');
      //$('.contact_select_01 input').attr('required','required');

      $('.contact_select_02').css('display', 'block');
      $('.contact_select_03').css('display', 'none');
      $('.send_field').css('display', 'block');
    } else if ( selected === '消耗品・付属品に関するお問合せ' ) {
      $('.contact_select_01').css('display', 'none');
      $('.contact_select_02').css('display', 'none');
      $('.contact_select_03').css('display', 'block');
      $('.send_field').css('display', 'none');
    } else if ( selected === 'キャンセル・返品・初期不良に関するお問合せ' ) {
      $('.contact_select_01').css('display', 'block');
      $('.contact_select_02').css('display', 'block');
      $('.contact_select_03').css('display', 'none');
      $('.send_field').css('display', 'block');
    } else {
      $('.contact_select_01').css('display', 'none');
      $('.contact_select_02').css('display', 'none');
      $('.contact_select_03').css('display', 'none');
      $('.send_field').css('display', 'none');
    }
  });
});

//商品詳細タブ
$(function() {
  $('.tab').on('click', function() {
    $('.tab, .panel').removeClass('active');
    $(this).addClass('active');
    var index = $('.tab').index(this);
    $('.panel').eq(index).addClass('active');
  });
});

//検索窓ブランクの場合はaction値強制書き換え
$(function() {  
  $(".main_search_1 .search__button").click(function () {
    // 検索窓のval値取得
    var main_search_catch_1 = $(".main_search_1 input").val();
    $(".main_search_1").submit(function() {
      if(main_search_catch_1 == null || main_search_catch_1 == "" ){
        $(".main_search_1").attr("action","/collections/all");
      }
    });
  });
});

$(function() {
  $(".main_search_2 .search__button").click(function () {
    // 検索窓のval値取得
    var main_search_catch_2 = $(".main_search_2 input").val();
    $(".main_search_2").submit(function() {
     if(main_search_catch_2 == null || main_search_catch_2 == "" ){
        $(".main_search_2").attr("action","/collections/all");
      }
    });
  });
});

$(function() {
  $(".main_search_3 .search__button").click(function () {
    // 検索窓のval値取得
    var main_search_catch_3 = $(".main_search_3 input").val();
    $(".main_search_3").submit(function() {
     if(main_search_catch_3 == null || main_search_catch_3 == "" ){
        $(".main_search_3").attr("action","/collections/all");
      }
    });
  });
});

//パーツ検索制御
$(function() {  
  $(".ts_contents_area .ts_search_field .search__button").click(function () {
    // 検索窓のval値取得
    var search_catch = $(".ts_contents_area .ts_search_field input").val();
    $("form").submit(function() {
      // submitした瞬間にval値を結合して書換え
      $('.ts_contents_area .ts_search_field input[name="q"]').val(search_catch + " " + "product_type:パーツ");
      //$('.ts_contents_area .ts_search_field input[name="q"]').val(search_catch + " " + "パーツ");
    });
  });
});

//検索結果の検索ウインドウからパラメータ文言削除
$(function() {
  if(document.URL.match(/search/)) {
    var search_catch_head = $(".ts_header .ts_search_field input").val();
    var result = search_catch_head.replace("product_type:パーツ", "");
    //var result = search_catch_head.replace("パーツ", "");
    $(".ts_header .ts_search_field input").val(result);
  }
});

// カテゴリページ タブカレント付与
$(function() {
  if(document.URL.match(/collections\//)) {
    $(".collection_brand_tab li a").each(function(){
      if(this.href == location.href) {
        $(this).parents("li").addClass("tab_current");
      }
    });
  }
});

// 個人情報提供同意
$(function() {
  $('#form_privacy_chack').change(function() {
    // チェックが入っていたら有効化
    if ( $(this).is(':checked') ){ 
        // ボタンを有効化
        $('.contact__button button').prop('disabled', false);
    } else { 
        // ボタンを無効化
        $('.contact__button button').prop('disabled', true); 
    }
  });
});

// PC・SPでJS実行分岐
$(window).on('load resize', function(){
  
  // SP（iPad）環境の場合
  if (window.matchMedia( '(max-width:768px)' ).matches) {
    
    // タブ部分をアンカーとして動作
    // $(function(){
    //   $(".tab-area .tab_01").click(function(){
    //     var target = $(".panel-area .panel_01");
    //     var position = $(target).offset().top;
    //     //$('html,body').animate({scrollTop: position}, 400);
    //     return false;
    //   });
    // });
    // $(function(){
    //   $(".tab-area .tab_02").click(function(){
    //     var target = $(".panel-area .panel_02");
    //     var position = $(target).offset().top;
    //     //$('html,body').animate({scrollTop: position}, 400);
    //     return false;
    //   });
    // });

  // PC環境の場合
  } else {

    //商品詳細タブ
    // $(function() {
    //   $('.tab').on('click', function() {
    //     $('.tab, .panel').removeClass('active');
    //     $(this).addClass('active');
    //     var index = $('.tab').index(this);
    //     $('.panel').eq(index).addClass('active');
    //   });
    // });
    
    // 左メニューカレント展開（URL毎に処理分岐）
    $(function() {
      // カテゴリALL
      if(document.URL.match(/collections\/all/)) {
        $(".sidemenu_ts .accordion-content").css("display","block");
        $(".sidemenu_ts .accordion-title").addClass("open");
      // 通常カテゴリ
      } else if(document.URL.match(/collections\//)) {
        $(".sidemenu_ts .accordion-container a").each(function(){
          if(this.href == location.href) {
            $(this).parents("p").addClass("current");      
            $(this).closest("div").css("display","block");
            $(this).parent().parent().prev().addClass("open");
          }
        });
      // その他ページ
      } else {
        $(".sidemenu_ts .accordion-content").css("display","block");
        $(".sidemenu_ts .accordion-title").addClass("open");
      }
    });

  };

});

// 上に戻るボタン
$(function(){
  var pagetop = $('#page-top');
  pagetop.hide();
  $(window).scroll(function () {
     if ($(this).scrollTop() > 100) {
          pagetop.fadeIn();
     } else {
          pagetop.fadeOut();
     }
  });
  pagetop.click(function () {
     $('body, html').animate({ scrollTop: 0 }, 500);
     return false;
  });
});
